module.exports = __webpack_public_path__ + "img/drug-21.454982c8.png";